// Encode data with illegal cookie value
// unsafe special characters: " ; = /
const encodeData = (value = "") => {
  return String(value).replace(/"|;|=|\/|~|%|`/g, function (data) {
    return encodeURIComponent(data);
  });
};

const decodeData = (value = "") => {
  return decodeURIComponent(value);
};

// Checker if data is parsable
function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

//@ SET COOKIE
//@ PARAMS (cookieName, data, expiration)
const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  let isObject = typeof value === "object";
  let data = isObject ? JSON.stringify(value) : value;
  const encodedData = encodeData(data);
  document.cookie = name + "=" + (encodedData || "") + expires + "; path=/";
};

const getCookie = (name) => {
  let result = document.cookie.match(new RegExp(name + "=([^;]+)"));
  if (result) {
    const decodedData = decodeData(result[1]);
    const parsedData = IsJsonString(decodedData) ? JSON.parse(decodedData) : decodedData;
    result && (result = parsedData);
  }

  return result;
};

// DELETE COOKIE PERMANENTLY
const removeCookie = (name) => {
  document.cookie = `${name}=turkey; path=/; max-age=0;`;
};

export default {
  setCookie,
  getCookie,
  removeCookie,
  decodeData,
  encodeData
};
